import React from 'react';
import './Modal.css';
import {FaCheck, FaExclamation} from 'react-icons/fa';
import {CSSTransition} from "react-transition-group";

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        }
    }

    componentDidMount() {
        this.setState({showModal: true});
    }

    render() {
        return (
            <div
                className="modal"
                onClick={() => {
                    this.setState({showModal: false});
                    setTimeout(() => {
                        this.props.exitModal();
                    }, 200);
                }}
            >
                <CSSTransition
                    in={this.state.showModal}
                    appear={true}
                    unmountOnExit
                    classNames="fade"
                    timeout={300}
                >
                    <div className='modal-msg'>
                        {this.props.children === 'Item has been added to your cart!' ?
                            <FaCheck size="4em"/> :
                            <FaExclamation size="4em"/>
                        }
                        <h3>{this.props.children}</h3>
                        <div className="buttons-container">
                            <button
                                type="button"
                                className="go-to-cart-btn"
                                onClick={() => this.props.redirect()}
                            >
                                Go to cart
                            </button>
                            <button
                                type="button"
                                className="keep-shopping-btn"
                            >
                                Keep shopping
                            </button>
                        </div>
                    </div>
                </CSSTransition>
            </div>
        );
    }
}

export default Modal;
